export default class SharpstarCallFailedError extends Error {
    constructor(message, errorCode) {
        super();
        this.name = `${errorCode ? `${errorCode} Code Error` : 'SharpstarCallFailedError'}`;
        this.message = message || 'Sharpstar call failed with no error message';
        this.code = errorCode;
    }
}
